export enum HttpErrors {
    Default = 'There was an issue. Please try again later.'
}
